import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {FmlxAccordion} from 'fmlx-common-ui';
import {useDispatch, useSelector} from 'react-redux';
import SingleProtocol from '../SingleProtocol';
import withIntl from '../../../lib/withIntl';
import {setProtocolExplorerExpandedGroups} from '../../../stores/actions/protocolExplorerAction';
import {getExpandedItemsArr} from '../../../stores/selectors/protocolExplorerSelectors';
import {getIsOperator} from '../../../stores/selectors/sessionSelectors';
import {getExplorerItemDataAttribute, protocolExplorerHelper} from '../../../lib/explorerHelper';

function ThumbnailView({
  protocols,
  folders,
  favoriteProtocols,
  onCheckIsRunning,
  onClickProtocol,
  onDoubleClickProtocol,
  greyedOutProtocolIds,
  onProtocolDropped,
  itemsRef,
}) {
  const dispatch = useDispatch();
  const isOperatorRoleLoggedIn = useSelector(getIsOperator);
  const expandedItems = useSelector((state) =>
    getExpandedItemsArr(state, favoriteProtocols.length, folders.length, protocols.length),
  );

  const handleChangeAccordion = (event, index, newExpanded) => {
    const items = {folders, protocols, favoriteProtocols};
    const newExpandedGroup = protocolExplorerHelper.handleAccordionClickAndGetExpandStatus(index, newExpanded, items);

    dispatch(setProtocolExplorerExpandedGroups(newExpandedGroup));
  };

  const [isDragMode, setIsDragMode] = useState(false);

  const handleBeginDrag = (protocol) => {
    if (protocol && !protocol.isSelected) {
      onClickProtocol(protocol);
    }
    setIsDragMode(true);
  };

  const handleEndDrag = () => {
    setIsDragMode(false);
  };

  let counter = 0;
  const generateContent = (items) => {
    const elements = items.map((protocol) => {
      const currentCounter = counter;
      counter++;
      return (
        <SingleProtocol
          ref={(el) => {
            if (!el?.node) return;

            itemsRef.current[currentCounter] = el.node;
          }}
          showFileExtension
          key={protocol.ID + protocol.type}
          selected={protocol.isSelected}
          selectableGroupItem={protocol}
          selectableKey={protocol.ID}
          protocol={protocol}
          isRunning={onCheckIsRunning(protocol[protocol.type].id, protocol.type)}
          onClick={onClickProtocol}
          onDoubleClick={onDoubleClickProtocol}
          greyedOut={greyedOutProtocolIds.includes(protocol.ID)}
          onBeginDrag={handleBeginDrag}
          onEndDrag={handleEndDrag}
          onDropped={onProtocolDropped}
          isDragMode={isDragMode}
          isOperatorRoleLoggedIn={isOperatorRoleLoggedIn}
          data={getExplorerItemDataAttribute(protocol, currentCounter)}
        />
      );
    });

    return {
      count: items.length,
      content: <div className="protocol-container-tile">{elements}</div>,
    };
  };

  const getItems = () => {
    const param = {
      favoriteProtocols: generateContent(favoriteProtocols),
      folders: generateContent(folders),
      protocols: generateContent(protocols),
    };

    const accordionItems = protocolExplorerHelper.generateAccordionItems(param);
    return accordionItems;
  };

  return (
    <FmlxAccordion
      id="accordion-protocol-explorer-thumbnail-view"
      multipleExpand
      expandedItems={expandedItems}
      onChange={handleChangeAccordion}
      iconPlacement="left"
      items={getItems()}
    />
  );
}

ThumbnailView.propTypes = {
  protocols: PropTypes.array,
  folders: PropTypes.array,
  favoriteProtocols: PropTypes.array,
  itemsRef: PropTypes.object,
  onCheckIsRunning: PropTypes.func,
  onClickProtocol: PropTypes.func,
  onDoubleClickProtocol: PropTypes.func,
  greyedOutProtocolIds: PropTypes.array,
  onProtocolDropped: PropTypes.func,
};

ThumbnailView.defaultProps = {
  protocols: [],
  folders: [],
  greyedOutProtocolIds: [],
  favoriteProtocols: [],
  itemsRef: {},
  onCheckIsRunning: () => false,
  onClickProtocol: () => {},
  onDoubleClickProtocol: () => {},
  onProtocolDropped: () => {},
};

export default withIntl(ThumbnailView);
